export default class Form {
	
	constructor()
	{
		Form.select();
		Form.footer_newsletter();
	}
	
	static select()
	{
		$( 'select' ).parent().not( '.formSelect' ).children( 'select' ).wrap( '<div class="formSelect"></div>' );
	}

	static footer_newsletter() {

		if( $('.page-id-233' ).length > 0 ) {
			var email = $POST_EMAIL;
			$( '#form_contact-newsletter .formGroupField input[type="email"]' ).val( email );
			$( '#form_contact-newsletter .formGroupField input[type="email"]' ).parent().parent().addClass('is-focused');
		}
	}
}